import { ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { getStoredTokens } from '@/core/utils/security.ts'

interface Props {
  children: ReactNode
  ifNotLoggedTo: string
}

export const LoginGuard = ({ children, ifNotLoggedTo }: Props) => {
  const location = useLocation()
  const authToken = getStoredTokens()

  if (!authToken) {
    return (
      <Navigate
        to={ifNotLoggedTo}
        state={{ from: location.pathname }}
        replace
      />
    )
  }

  return children ? children : <Outlet />
}
